'use client';
import { type Guard, useQueuedGuards } from '@capsicum/common';
import { type ComponentType, useEffect } from 'react';
import { match } from 'ts-pattern';

import { useRouter } from '../../../hooks/router/useCustomRouter';

export function withRouteGuard<T extends {}>(
	WrappedComponent: ComponentType<T>,
	guards: Array<Guard>,
	LoadingComponent: ComponentType
) {
	const Wrapped = (props: T) => {
		const router = useRouter();

		const { onDenied, status } = useQueuedGuards(guards);

		// Redirect after render to avoid error "Cannot update a component while rendering a different component"
		useEffect(() => {
			if (status === 'denied') {
				onDenied();
			}
		}, [status, router, onDenied]);

		return match(status)
			.with('allowed', () => <WrappedComponent {...props} />)
			.otherwise(() => <LoadingComponent />);
	};

	return Wrapped;
}
